import { render } from "./StatsCards.vue?vue&type=template&id=e02cc516&scoped=true"
import script from "./StatsCards.vue?vue&type=script&lang=js"
export * from "./StatsCards.vue?vue&type=script&lang=js"

import "./StatsCards.vue?vue&type=style&index=0&id=e02cc516&scoped=true&lang=css"

import exportComponent from "C:\\Users\\guifernandespro\\development\\projects\\vue_icon-website\\node_modules\\vue-loader-v16\\dist\\exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-e02cc516"]])

export default __exports__